import { combineReducers } from 'redux';
import basicDetailsReducer from './basicDetailsSlice';
import templateReducer, { defaultTemplateSlice } from './templateSlice';
import candidateReducer from './candidateSlice';
import currentWorkflowItemReducers from './currentWorkflowItemSlice';
import headerDetailsReducers from './headerDetailsSlice';

export const reducers = combineReducers({
  basicDetails: basicDetailsReducer,
  template: templateReducer,
  candidate: candidateReducer,
  currentWorkflowItem: currentWorkflowItemReducers,
  headerDetails: headerDetailsReducers,
  defaultTemplate: defaultTemplateSlice.reducer,
});
